export const initialState = {
  loadingStatus: {
    loginLoading: false,
    logoutLoading: false,
    forgotPasswordLoading: false,
    verifyCodeLoading: false,
    changePasswordLoading: false,
  },
  error: '',
  data: {},
  loginStatus: null,
};
